module.exports = __webpack_public_path__ + "img/invoice-de-female-hb.95b7c957.png";